/**
 * @callback openDialog
 * @param {Event} evt
 * @param {string} dialogId
 */

/**
 * Attaches event listeners to buttons by id and calls the provided callback with dialogId as a parameter.
 * @param {string} buttonId
 * @param {string} datasetId
 * @param {openDialog} callback
 */
function attachEventListener(buttonId, datasetId, callback) {
    document.querySelectorAll(`[${buttonId}]`).forEach((button) => {
        const dialogId = button.dataset[datasetId];
        button.addEventListener('click', (e) => callback(e, dialogId));
    });
}

/**
 * Gets the dialog element from the DOM by the provided id and opens it.
 * @param {Event} evt
 * @param {string} dialogId
 */
function openDialog(evt, dialogId) {
    /**
     * @type {HTMLDialogElement}
     */
    const dialogElement = document.querySelector(`#${dialogId}`);
    dialogElement.showModal();
}

/**
 * Gets the dialog element from the DOM by the provided id and closes it.
 * @param {Event} evt
 * @param {string} dialogId
 */
function closeDialog(evt, dialogId) {
    /**
     * @type {HTMLDialogElement}
     */
    const dialogElement = document.querySelector(`#${dialogId}`);
    dialogElement.close();
}

export default function InitDialog() {
    attachEventListener('data-dialog-open-handle', 'dialogOpenHandle', openDialog);
    attachEventListener('data-dialog-close-handle', 'dialogCloseHandle', closeDialog);
}
